import { Link } from 'react-router-dom';
import { siteFooterLinks } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="mt-20 w-full border-t bg-secondary-950 hairline">
      <div className="mx-auto w-full px-4 py-14 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5 lg:gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-base font-black text-background-50">
                黑
              </span>
              <span className="font-heading text-lg font-black text-background-50">爱黑料网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-200">
              聚合评论区与讨论区的热评风向，把网友热议的吃瓜帖收进索引，点开就能看到围观现场。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-message-3-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="社交入口"
                  className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-secondary-700 text-secondary-200 transition-colors hover:border-primary-400 hover:text-primary-300"
                >
                  <i className={`${icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {siteFooterLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="cursor-pointer text-sm text-secondary-200 transition-colors hover:text-primary-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-3 border-t border-secondary-800 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-secondary-300">
            本站内容为网友讨论与围观整理，仅供娱乐参考。
          </p>
          <p className="text-xs text-secondary-300">
            爱黑料网 · 评论区与讨论区热评聚合
          </p>
        </div>
      </div>
    </footer>
  );
}